export default __webpack_public_path__ + "images/1885f3ebd8d364aad969228ec581a8e8.jpg";